import { MaritalStatuses } from '../../../global/constants/lists';
import { LabelSettingProps } from '../../../global/models/epi-model';

export function getMaritalStatusText(maritalStatus: string, labelSettings: LabelSettingProps) {
    switch (maritalStatus) {
        case MaritalStatuses.Married:
            return labelSettings.marriedText;
        case MaritalStatuses.Divorced:
            return labelSettings.divorcedText;
        case MaritalStatuses.Widowed:
            return labelSettings.widowedText;
        default:
            return labelSettings.singleText;
    }
}